import { getFragmentData, graphql } from "../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { TeacherSubstitutionResultFragment } from "./TeacherSubstitutionResultFragment.ts";
import { TeacherSubstitutionResultGraphqlDto } from "../gql/graphql.ts";

const Try1on1TeacherSubstitutionMutation = graphql(`
  mutation try1on1TeacherSubstitution($intentId: String!, $timezone: String) {
    try1on1TeacherSubstitution(intentId: $intentId, timezone: $timezone) {
      ...TeacherSubstitutionResult
    }
  }
`);

export function useTry1on1TeacherSubstitution() {
  const [try1on1TeacherSubstitutionMutation, { loading }] = useMutation(
    Try1on1TeacherSubstitutionMutation,
  );

  const try1on1TeacherSubstitution = useCallback(
    async (
      intentId: string,
      timezone?: string,
    ): Promise<TeacherSubstitutionResultGraphqlDto> => {
      const res = await try1on1TeacherSubstitutionMutation({
        variables: {
          intentId,
          timezone,
        },
      });

      const result = getFragmentData(
        TeacherSubstitutionResultFragment,
        res.data?.try1on1TeacherSubstitution,
      );

      if (!result) throw new Error("Unable to perform teacher substitution");

      return result;
    },
    [try1on1TeacherSubstitutionMutation],
  );

  return {
    loading,
    try1on1TeacherSubstitution,
  };
}
